module.exports = __webpack_public_path__ + "static/media/subjectToChange.4f482cab.jpg";